import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataBagService } from 'src/app/common/data-bag.service';
import { OrganizationService } from '../../organization.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';

export interface WorkersData {
	id: number;
	user: {
		email: string;
		password: string;
		firstName: string;
		lastName: string;
	};
	termOfOffice: null;
	department: number;
	role: number;
}

@Component({
	selector: 'app-organization-workers-edit',
	templateUrl: './organization-workers-edit.component.html',
	styleUrls: ['./organization-workers-edit.component.scss'],
})
export class OrganizationWorkersEditComponent implements OnInit {
	workerData = {
		id: null,
		user: {
			email: null,
			password: null,
			firstName: null,
			lastName: null,
		},
		department: null,
		role: null,
	};

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: WorkersData,
		public service: OrganizationService,
		public bag: DataBagService,
		protected infobox: InfoboxService,
		private readonly dialogRef: MatDialogRef<any>,
	) {}

	ngOnInit(): void {
		this.workerData = this.data;
	}

	getDepartment(department) {
		return this.service.enterpriseData.departmentKinds.find((findDep) => findDep.id === department).name;
	}

	workerSave() {
		this.bag.put(`/organization/user/${this.workerData.id}/`, this.workerData, (result, error) => {
			if (error) {
				return;
			}
			this.dialogRef.close(true);
		});
	}
}
